package com.milta.feature.admin.domain.usecase

import com.milta.feature.admin.domain.entity.AdminPrompt
import com.milta.feature.admin.domain.repository.AdminRepository

class UpdatePromptUseCase(private val repository: AdminRepository) {
    suspend operator fun invoke(key: String, body: String): Result<AdminPrompt> = repository.updatePrompt(key, body)
}
